<template>
  <div class="loading-spinner tw-animate-spin tw-icon tw-icon-laden"></div>
</template>

<script>
export default {};
</script>

<style scoped></style>
